import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import EmailSignInForm from '../components/sign-in-form';
import {Link} from 'react-router-dom';
import Auth from '../components/auth';
import {emailSignIn} from '../../actions/auth';
import {AUTH_SIGNOUT_SUCCESS} from "../../actions/types";
import {Button} from "react-bootstrap";
import {apiFetch} from "../../apiFetch";
import {toast} from 'react-toastify';
import {API_NEW_PORTAL} from "../../configs/apis";


class SignInContainer extends Component {
    static propTypes = {
        isLoading: PropTypes.bool,
    };

    signIn = (values) => {
        this.props.dispatch(emailSignIn(values))
    };

    backToSignIn = () => {
        this.props.dispatch({type: AUTH_SIGNOUT_SUCCESS});
    };

    redirectToNewPortal = () => {

        apiFetch(API_NEW_PORTAL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'get',
        }).then(response => {
            window.open(response.link);
        }).catch(e => {
                toast.error(e.error);
            });

        return (<div></div>)

    };


    render() {

        const style = {
            float: 'right',
        };

        if (this.props.userMigrated) {
            return (
                <Auth title="Congratulations!">
                    <small
                    >
                        You've been upgraded to our new Patient Portal. Follow this link for an enhanced patient
                        experience.
                    </small>

                    <div className={"sign-in-link-success"}>
                        <Link to={"/signin"} onClick={this.backToSignIn}>
                            <i className="glyphicon glyphicon-menu-left"/>
                            Back to Sign In
                        </Link>
                        <Button type="submit" className="pull-right" onClick={this.redirectToNewPortal}>
                            Go{/*<a href="https://www.google.com">Go</a>*/}
                        </Button>
                    </div>

                </Auth>)
        } else return (
      <Auth title='Welcome to Finpay'>
        <EmailSignInForm
          isLoading={this.props.isLoading}
          signIn={this.signIn}
        />
        <div className='forgot-pw-link'>
          <Link to={'/forgot-password'}>Did you forget your password?</Link>
        </div>
      </Auth>
    );
  }

}

function mapStateToProps({auth: {isLoading}}) {
  return {
    isLoading
  }
}
export default connect(mapStateToProps)(SignInContainer);



// WEBPACK FOOTER //
// ./src/auth/containers/sign-in.js